import React from "react";

import { SettingRow } from "../SettingRow";
import { RadioGroup } from "../../../../../../common/components/input/RadioGroup";
import { ConsentBannerScreenPosition } from "../../../../../../common/service/server/dto/CMPSettingsDto";

export const ConsentBannerScreenPositionRow = () => {
  return (
    <SettingRow
      maxWidthChildren={true}
      title="Screen Position"
      helpText="Select the location where your consent banner will appear on your website. Bottom left is most common."
    >
      <RadioGroup
        field="bannerScreenPosition"
        aria-label="Screen Position"
        className="align-items-center"
        row
        options={[
          {
            value: ConsentBannerScreenPosition.BOTTOM_LEFT,
            label: "Bottom Left",
          },
          {
            value: ConsentBannerScreenPosition.BOTTOM_CENTER,
            label: "Bottom Center",
          },
          {
            value: ConsentBannerScreenPosition.BOTTOM_RIGHT,
            label: "Bottom Right",
          },
          {
            value: ConsentBannerScreenPosition.MIDDLE_CENTER,
            label: "Center Screen",
          },
        ]}
      />
    </SettingRow>
  );
};
